import BaseAPI from "@/apis/base/base-api";
import httpClient from "@/apis/base/axios-httpclient";

class AuthAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Auth";
  controllerName = "account";

  /**
   * Lấy URL login MISA ID từ MerchantAuth service (302 sang trang đăng nhập MISA ID)
   * UpdatedBy: tstung (03/11/2026)
   * @param {string} returnUrl - URL quay về sau khi đăng nhập (optional)
   * @returns {string} URL login
   */
  getMisaIdLoginUrl() {
    return `${window._apis.MerchantAuth}/api/misa-id/login`;
  }

  /**
   * URL callback MISA ID — dùng top-level navigation (không XHR) để backend set cookie HttpOnly rồi 302 về /misaid
   * UpdatedBy: tstung (04/11/2026)
   * @param {{ code: string, state: string }} params
   * @returns {string} URL callback
   */
  getMisaIdCallbackUrl({ code, state }) {
    const params = new URLSearchParams({ code, state });
    return `${window._apis.MerchantAuth}/api/misa-id/callback/login?${params.toString()}`;
  }

  /**
   * Lấy session user/merchant/role sau khi backend xác thực cookie
   * UpdatedBy: tstung (04/11/2026)
   * @returns {Promise<object>} Session context, không chứa JWT
   */
  async getMisaIdSession() {
    return httpClient.getAsync({
      url: `${window._apis.MerchantAuth}/api/misa-id/session`,
    });
  }

  /**
   * Kết thúc session MerchantAuth và lấy URL logout MISA ID
   * UpdatedBy: tstung (04/11/2026)
   * @returns {Promise<object>} Logout response
   */
  async logoutMisaId() {
    return httpClient.postAsync({
      url: `${window._apis.MerchantAuth}/api/misa-id/logout`,
    });
  }
}

export default new AuthAPI();
